/**
 * Replaces all route params in the string with the provided values
 * @example prepareUrl('/users/:userId/:articleId/pages', [1,2]) -> '/users/1/2/pages'
 */
export function prepareUrl(url: string, params: string[]): string {
  const segments = url.split('/');
  return segments
    .map(segment => {
      if (segment.startsWith(':')) {
        return params.shift();
      }
      return segment;
    })
    .join('/')
    .replace(/\/$/, '');
}
